import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetFjJobQuery } from '../../../../../../redux/services/fj_jobs.jsx';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import { Spinner } from '../../../../../common/index.jsx';
import FjJobDetail from '../../../../../common/FriJobs/FjJobDetail.jsx';

const FjJobsDetailPage = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const { data: job, isLoading } = useGetFjJobQuery(id);

  const pageTitle = t('Detail pracovnej ponuky');

  useEffect(() => {
    document.title = pageTitle + ' - FRI.jobs';
  }, [pageTitle]); // Runs on mount

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={pageTitle}
        backUrl={-1}
        backUrlTooltip={t('Nástenka')}
      />
      <div style={{ margin: '10px' }}>
        <FjJobDetail jobData={job} />
      </div>
    </>
  );
};

export default FjJobsDetailPage;
